<template>
    <section class="section section--lode games-page">
        <b-container>
            <div class="lobby-lode dis-flex just-between">
                <div class="lobby-lode__item" v-for="(item, index) in ListLode" :key="index">
                    <a href="javascript:void(0)" @click.prevent="moveTo(item)" :title="item.title">
                        <div class="thumb">
                            <img class="background" :src="item.background" :alt="item.title" />
                            <img class="content" :src="item.content" :alt="item.title" />
                        </div>
                        <div class="btn-play">
                            <img src="/assets/img/lode/btn-play.png" alt="Chơi ngay">
                        </div>
                    </a>
                </div>
            </div>
        <game-section
            :seeMoreLink="'/tro-choi?type=quay-so'"
            :items="games"
            :title="'ĐỪNG ĐỢI TỚI 4 GIỜ CHIỀU'"/>
        </b-container>
    </section>
</template>
<script>

import gameSection from './home/game-section.vue';

export default {
    components: { gameSection },
    mounted() {
        this.getGameLode();
    },

    data() {
        return {
            ListLode: [
                {
                    background: '/assets/img/lode/bg-lode3mien.png',
                    content: '/assets/img/lode/content-lode3mien.png',
                    title: 'lô đề 3 miền',
                    link: '/lode',
                    newTab: true
                },
                {
                    background: '/assets/img/lode/bg-lodesieutoc.png',
                    content: '/assets/img/lode/content-lodesieutoc.png',
                    title: 'lô đề Siêu tốc',
                    link: '/lo-de-sieu-toc',
                    newTab: true
                }
            ],
            games: []
            // games: [
            //     {
            //         tag: 'keno, lottery, vingame',
            //         id: 2028,
            //         partner_game_id: 'vinkeno',
            //         url: '/keno',
            //         type: [
            //             '1'
            //         ],
            //         shouldFetchLink: false,
            //         maintain: '0',
            //         name: 'Keno',
            //         image: 'https://dev05.oxbet.com/assets/img/uploads/2023/03/keno.jpeg',
            //         partner_provider: 'vingame',
            //         display_types: [
            //             7
            //         ]
            //     }, {
            //         tag: 'keno, lottery',
            //         id: 2037,
            //         partner_game_id: 'athena-keno',
            //         type: [
            //             '1'
            //         ],
            //         shouldFetchLink: false,
            //         maintain: '0',
            //         name: 'Keno Saba',
            //         image: 'https://dev05.oxbet.com/assets/img/uploads/2023/06/keno.jpg',
            //         partner_provider: 'athena',
            //         display_types: [
            //             7
            //         ]
            //     }, {
            //         tag: 'numbers game, lottery, vingame',
            //         id: 2029,
            //         partner_game_id: 'vinnumbersgame',
            //         url: '/tro-choi-so',
            //         type: [
            //             '1'
            //         ],
            //         shouldFetchLink: false,
            //         maintain: '0',
            //         name: 'Numbers game',
            //         image: 'https://dev05.oxbet.com/assets/img/uploads/2023/03/number-game.jpeg',
            //         partner_provider: 'vingame',
            //         display_types: [
            //             7
            //         ]
            //     },
            //     {
            //         tag: 'numbers game, lottery, vingame',
            //         id: 2036,
            //         partner_game_id: 'athena-numbergame',
            //         type: [
            //             '1'
            //         ],
            //         shouldFetchLink: false,
            //         maintain: '0',
            //         name: 'Numbers Game Saba',
            //         image: 'https://dev05.oxbet.com/assets/img/uploads/2023/06/number-1.jpg',
            //         partner_provider: 'athena',
            //         display_types: [
            //             7
            //         ]
            //     }
            // ]

        };
    },
    methods: {
        async getGameLode() {
            const res = await this.$gameApi.index();
            if (res.status === 'OK') {
                this.games = res.data.asia.lottery.items.filter(game => {
                    if (game.tag) {
                        if (game.tag.includes('lode')) {
                            return true;
                        }
                    }
                    return false;
                });
                console.error('WTF', this.games);
            }
        },
        moveTo(item) {
            if (this.$isMobile()) {
                this.$openLink(`${this.$store.state.mapDomain.GAME_URL}?url=${item.link}`, {
                    newTab: item.newTab
                });
            } else {
                this.$router.push(item.link);
            }
        }
    }
};
</script>
